import React, { ReactNode, useEffect, useRef } from 'react';

interface Iprops {
    children: ReactNode;
    visible: boolean;
    className?: string;
    onUnderlayClick?: () => void;
}

const SideModal: React.FC<Iprops> & {
    Header: React.FC<{ children: ReactNode }>;
    Body: React.FC<{ children: ReactNode }>;
    Footer: React.FC<{ children: ReactNode }>;
} = props => {
    const { children, visible, className, onUnderlayClick } = props;

    // Use refs to target this specific modal instance
    const underlayRef = useRef<HTMLDivElement>(null);
    const modalRef = useRef<HTMLDivElement>(null);

    // animation is handled by css
    useEffect(() => {
        const underlay = underlayRef.current;
        const modal = modalRef.current;
        if (visible) {
            underlay?.classList.add('visible');
            modal?.classList.add('visible');
        } else {
            underlay?.classList.remove('visible');
            modal?.classList.remove('visible');
        }
    }, [visible]);

    // ensure that the click event is on the underlay and not the modal itself
    const handleUnderlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e.target === e.currentTarget && onUnderlayClick) onUnderlayClick();
    };

    return (
        <div ref={underlayRef} className="side-modal-underlay" onClick={handleUnderlayClick}>
            <div ref={modalRef} className={`side-modal ${className}`}>
                {children}
            </div>
        </div>
    );
};

SideModal.Header = ({ children }) => <div className="side-modal-header">{children}</div>;
SideModal.Body = ({ children }) => <div className="side-modal-body">{children}</div>;
SideModal.Footer = ({ children }) => <div className="side-modal-footer">{children}</div>;

export default SideModal;
